export type Specialist = {
  name: string,
  photo: string,
  description: string,
}

const SPECIALISTS_BY_GROUP: Record<string, Specialist[]> = {
  // ExpandMentor / LeadForwardPro / InvestGuidesPro / ProManagerGuide / ProMarketingPath
  "18": [
    {
      name: "Priya K.",
      photo: "/images/experts/expert-18-1.jpg",
      description: "Expert in management and team leadership, covering people management, performance reviews, delegation, and the practical systems that help managers build stronger, higher-performing teams.",
    },
    {
      name: "Owen R.",
      photo: "/images/experts/expert-18-2.jpg",
      description: "Expert in business mentorship and personal growth, helping professionals build confidence, set clear goals, and develop the mindset, habits, and decision-making skills needed to move their career and business forward.",
    },
    {
      name: "Daniel F.",
      photo: "/images/experts/expert-18-3.jpg",
      description: "Expert in marketing strategy and investment planning, covering digital marketing, brand growth, portfolio diversification, and the financial fundamentals behind building long-term wealth.",
    },
  ],
  // masterylabpro / wealthmasterlab / riseleaderhub / managerflowpro / marketriselab
  "19": [
    {
      name: "Nadia S.",
      photo: "/images/experts/expert-19-1.jpg",
      description: "Expert in business mastery and performance growth, helping entrepreneurs sharpen strategy, build effective systems, and develop the skills needed to scale a business with confidence.",
    },
    {
      name: "Marcus T.",
      photo: "/images/experts/expert-19-2.jpg",
      description: "Expert in leadership and team performance, covering people management, workflow optimization, delegation, and the practical tools that help managers run smoother, more productive teams.",
    },
    {
      name: "Gregory V.",
      photo: "/images/experts/expert-19-3.jpg",
      description: "Expert in wealth building and market strategy, covering investment fundamentals, portfolio growth, financial planning, and the practical steps for turning market opportunity into long-term wealth.",
    },
  ],
  // propathwayhub / growwisepro / leaderahub / managixpro / marketbuildpro
  "20": [
    {
      name: "Sophie L.",
      photo: "/images/experts/expert-20-1.jpg",
      description: "Expert in leadership and management fundamentals, covering team building, performance management, communication skills, and the everyday tools that help leaders manage with confidence.",
    },
    {
      name: "Jason B.",
      photo: "/images/experts/expert-20-2.jpg",
      description: "Expert in career pathway planning and personal growth, helping professionals set clear direction, build practical skills, and make confident decisions at every stage of their career.",
    },
    {
      name: "Victor N.",
      photo: "/images/experts/expert-20-3.jpg",
      description: "Expert in market strategy and business growth, covering brand positioning, market research, growth planning, and the practical steps for building a stronger, more competitive business.",
    },
  ],
  // bondoralife / famoralife / hermindstudy / himologia / maritify
  "21": [
    {
      name: "Adrian M.",
      photo: "/images/experts/expert-21-1.svg",
      description: "Expert in relationship building and emotional connection, helping couples strengthen communication, deepen trust, and build the habits that keep a relationship strong through every stage of life.",
    },
    {
      name: "Claire P.",
      photo: "/images/experts/expert-21-2.svg",
      description: "Expert in family dynamics and relationship psychology, covering communication patterns, conflict resolution, and practical strategies for building stronger, more supportive family relationships.",
    },
    {
      name: "Ryan W.",
      photo: "/images/experts/expert-21-3.svg",
      description: "Expert in marriage counseling and long-term relationship strategy, covering commitment, trust-building, and the practical tools couples need to navigate challenges and grow together.",
    },
  ],
}

const DEFAULT_SPECIALISTS = SPECIALISTS_BY_GROUP["19"]

export function getSpecialists(templateGroup?: string): Specialist[] {
  return (templateGroup && SPECIALISTS_BY_GROUP[templateGroup]) || DEFAULT_SPECIALISTS
}
